export enum SectionType {
  BANNER_TIMER = 'BANNER_TIMER',
  PSYCHIC_SERVICE = 'PSYCHIC_SERVICE',
  OFFER_V2 = 'OFFER_V2',
  OFFER_DISCLAIMER_PRIORITY = 'OFFER_DISCLAIMER_PRIORITY',
  GUIDE_V2 = 'GUIDE_V2',
  SCAN_CAROUSEL = 'SCAN_CAROUSEL',
  COMPARISON_V2 = 'COMPARISON_V2',
  LEARN_WITH_NEBULA = 'LEARN_WITH_NEBULA',
  PARTNERS_WITH_ANIMATION = 'PARTNERS_WITH_ANIMATION',
  FAQ = 'FAQ',
  INFO = 'INFO',
  OFFER = 'OFFER',
  TRIAL_OFFER = 'TRIAL_OFFER',
  GUIDE = 'GUIDE',
  BADGE = 'BADGE',
  QUOTE = 'QUOTE',
  HEADER = 'HEADER',
  FAQ_V2 = 'FAQ_V2',
  BANNER = 'BANNER',
  RATING = 'RATING',
  REVIEWS = 'REVIEWS',
  REVIEWS_V2 = 'REVIEWS_V2',
  INSIDES = 'INSIDES',
  PAYMENT = 'PAYMENT',
  EXPERTS = 'EXPERTS',
  BENEFITS = 'BENEFITS',
  PARTNERS = 'PARTNERS',
  GUARANTEE = 'GUARANTEE',
  HIGHLIGHTS = 'HIGHLIGHTS',
  PAYMENT_V2 = 'PAYMENT_V2',
  ADVANTAGES = 'ADVANTAGES',
  CARD_WITH_IMAGE_OVERLAPPED = 'CARD_WITH_IMAGE_OVERLAPPED',
  ADVANTAGES_WITH_DESCRIPTION = 'ADVANTAGES_WITH_DESCRIPTION',
  ADVANTAGES_WITH_DESCRIPTION_V2 = 'ADVANTAGES_WITH_DESCRIPTION_V2',
  COMPARISON = 'COMPARISON',
  INTRO_OFFER = 'INTRO_OFFER',
  DECK_SLIDER = 'DECK_SLIDER',
  OFFER_MODAL = 'OFFER_MODAL',
  ORDER_SUMMARY_MODAL_V2 = 'ORDER_SUMMARY_MODAL_V2',
  FEATURED_IN = 'FEATURED_IN',
  BENEFITS_V2 = 'BENEFITS_V2',
  WHAT_INSIDE = 'WHAT_INSIDE',
  TRIAL_CHOICE = 'TRIAL_CHOICE',
  MENTIONED_IN = 'MENTIONED_IN',
  PAYWALL_HERO = 'PAYWALL_HERO',
  WHAT_YOU_GET = 'WHAT_YOU_GET',
  PALM_ANALYSIS = 'PALM_ANALYSIS',
  SUCCESS_ORDER = 'SUCCESS_ORDER',
  UPSELL_OFFERS = 'UPSELL_OFFERS',
  NEBULA_RATING = 'NEBULA_RATING',
  PROMO_CODE = 'PROMO_CODE',
  PLAN_TIMELINE = 'PLAN_TIMELINE',
  DISCOUNT_MODAL = 'DISCOUNT_MODAL',
  PAYWALL_HEADER = 'PAYWALL_HEADER',
  PAYWALL_FOOTER = 'PAYWALL_FOOTER',
  INTRO_OFFER_V2 = 'INTRO_OFFER_V2',
  INTRO_OFFER_V3 = 'INTRO_OFFER_V3',
  INTRO_OFFER_V4 = 'INTRO_OFFER_V4',
  INTRO_OFFER_V5 = 'INTRO_OFFER_V5',
  INTRO_OFFER_IOS = 'INTRO_OFFER_IOS',
  PLANS_OVERVIEW = 'PLANS_OVERVIEW',
  DISCOUNT_TICKET = 'DISCOUNT_TICKET',
  DISCOUNT_BANNER = 'DISCOUNT_BANNER',
  UPSELL_GUIDANCE = 'UPSELL_GUIDANCE',
  BLURRED_CONTENT = 'BLURRED_CONTENT',
  BANNER_CLICKABLE = 'BANNER_CLICKABLE',
  REVIEWS_CAROUSEL = 'REVIEWS_CAROUSEL',
  SUMMARY_PROGRESS = 'SUMMARY_PROGRESS',
  DISCOUNT_MODAL_V2 = 'DISCOUNT_MODAL_V2',
  DISCOUNT_MODAL_V3 = 'DISCOUNT_MODAL_V3',
  PRECHECKOUT_MODAL = 'PRECHECKOUT_MODAL',
  NAVIGATION_HEADER = 'NAVIGATION_HEADER',
  RELATIONSHIP_PLAN = 'RELATIONSHIP_PLAN',
  PERSONALIZED_GUIDE = 'PERSONALIZED_GUIDE',
  PERSONALIZED_GUIDE_V2 = 'PERSONALIZED_GUIDE_V2',
  TRIAL_CHOICE_MODAL = 'TRIAL_CHOICE_MODAL',
  DISCOUNT_BANNER_V2 = 'DISCOUNT_BANNER_V2',
  INSIGHTS_DETAILS = 'INSIGHTS_DETAILS',
  INSIGHT_PREVIEW = 'INSIGHT_PREVIEW',
  INSIGHT_PREVIEW_V2 = 'INSIGHT_PREVIEW_V2',
  USER_ZODIAC_DETAILS = 'USER_ZODIAC_DETAILS',
  READINGS_PACK_SLIDER = 'READINGS_PACK_SLIDER',
  MONEY_BACK_GUARANTEE = 'MONEY_BACK_GUARANTEE',
  ADVANTAGES_WITH_EMOJI = 'ADVANTAGES_WITH_EMOJI',
  ATTACHMENT_STYLE_PROFILE = 'ATTACHMENT_STYLE_PROFILE',
  UPSELL_CONSULTATION_OFFER = 'UPSELL_CONSULTATION_OFFER',
  UPSELL_READINGS_PACK_OFFER = 'UPSELL_READINGS_PACK_OFFER',
  UPSELL_CONSULTATION_INSIGHTS = 'UPSELL_CONSULTATION_INSIGHTS',
  UPSELL_CONSULTATION_BENEFITS = 'UPSELL_CONSULTATION_BENEFITS',
  UPSELL_GUIDANCE_WITH_ANSWERS = 'UPSELL_GUIDANCE_WITH_ANSWERS',
  UPSELL_CONSULTATION_GUARANTEE = 'UPSELL_CONSULTATION_GUARANTEE',
  UPSELL_GUIDANCE_WITH_ANSWERS_CAROUSEL = 'UPSELL_GUIDANCE_WITH_ANSWERS_CAROUSEL',
  BEFORE_AFTER = 'BEFORE_AFTER',
  LEGACY_LIST = 'LEGACY_LIST',
  LEGACY_FOOTER = 'LEGACY_FOOTER',
  LEGACY_BANNER = 'LEGACY_BANNER',
  LEGACY_REVIEWS = 'LEGACY_REVIEWS',
  LEGACY_INFO_PANEL = 'LEGACY_INFO_PANEL',
  LEGACY_MEDIA_PANEL = 'LEGACY_MEDIA_PANEL',
  LEGACY_PRICE_PANEL = 'LEGACY_PRICE_PANEL',
  LEGACY_MONEY_BACK_GUARANTEE = 'LEGACY_MONEY_BACK_GUARANTEE',
  SUBSCRIPTION_DISCOUNT = 'SUBSCRIPTION_DISCOUNT',
  AUDIO_SESSION = 'AUDIO_SESSION',
  SHORT_UPSELL_OFFER_CARD = 'SHORT_UPSELL_OFFER_CARD',
  SHORT_UPSELL_OFFER = 'SHORT_UPSELL_OFFER',
  ECOMMERCE_HEADER = 'ECOMMERCE_HEADER',
  ECOMMERCE_PRODUCT = 'ECOMMERCE_PRODUCT',
  ECOMMERCE_ABOUT_US = 'ECOMMERCE_ABOUT_US',
  ECOMMERCE_FOOTER = 'ECOMMERCE_FOOTER',

  NEB_BENEFITS = 'NEB_BENEFITS',
  NEB_FAQ = 'NEB_FAQ',
  NEB_PARTNERS = 'NEB_PARTNERS',
  NEB_SPECIAL_OFFER = 'NEB_SPECIAL_OFFER',
  NEB_PAYMENT = 'NEB_PAYMENT',
  NEB_FEEDBACK_CARDS = 'NEB_FEEDBACK_CARDS',
  NEB_BLURRED_REPORT = 'NEB_BLURRED_REPORT',
  NEB_USER_DETAILS = 'NEB_USER_DETAILS',
  NEB_TIMER_BANNER = 'NEB_TIMER_BANNER',
}
